import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "header-actions" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminHeaderActions',
    props: {
        loading: { type: Boolean, default: false },
        hasId: { type: Boolean, default: true },
        showDelete: { type: Boolean, default: true },
        saveLabel: { default: '💾 Save' },
        deleteLabel: { default: '🗑️ Delete' },
        newLabel: { default: '➕ New' }
    },
    emits: ["save", "delete", "new"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function onSave() {
            emit('save');
        }
        function onDelete() {
            emit('delete');
        }
        function onNew() {
            emit('new');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "action-btn primary",
                    onClick: onSave,
                    disabled: _ctx.loading
                }, _toDisplayString(_ctx.saveLabel), 9, _hoisted_2),
                (_ctx.showDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "action-btn danger",
                        onClick: onDelete,
                        disabled: _ctx.loading || !_ctx.hasId
                    }, _toDisplayString(_ctx.deleteLabel), 9, _hoisted_3))
                    : _createCommentVNode("", true),
                _createElementVNode("button", {
                    class: "action-btn secondary",
                    onClick: onNew,
                    disabled: _ctx.loading
                }, _toDisplayString(_ctx.newLabel), 9, _hoisted_4)
            ]));
        };
    }
});
